import { Order, MainWorkOrder, SubWorkOrder, Person, Machine, Material, Product, Workflow } from '@/types';
import ordersData from '@/data/orders.json';
import mainWorkOrdersData from '@/data/main-work-orders.json';
import subWorkOrdersData from '@/data/sub-work-orders.json';
import personsData from '@/data/persons.json';
import machinesData from '@/data/machines.json';
import materialsData from '@/data/materials.json';
import productsData from '@/data/products.json';
import workflowsData from '@/data/workflows.json';

// 載入所有參考資料
export async function loadReferenceData() {
  // 模擬異步載入
  return Promise.resolve({
    orders: ordersData as Order[],
    mainWorkOrders: mainWorkOrdersData as MainWorkOrder[],
    subWorkOrders: subWorkOrdersData as SubWorkOrder[],
    persons: personsData as Person[],
    machines: machinesData as Machine[],
    materials: materialsData as Material[],
    products: productsData as Product[],
    workflows: workflowsData as Workflow[],
  });
}

// 載入單一資料類型
export async function loadOrders(): Promise<Order[]> {
  return ordersData as Order[];
}

export async function loadMainWorkOrders(): Promise<MainWorkOrder[]> {
  return mainWorkOrdersData as MainWorkOrder[];
}

export async function loadSubWorkOrders(): Promise<SubWorkOrder[]> {
  return subWorkOrdersData as SubWorkOrder[];
}

export async function loadPersons(): Promise<Person[]> {
  return personsData as Person[];
}

export async function loadMachines(): Promise<Machine[]> {
  return machinesData as Machine[];
}

export async function loadMaterials(): Promise<Material[]> {
  return materialsData as Material[];
}

export async function loadProducts(): Promise<Product[]> {
  return productsData as Product[];
}

export async function loadWorkflows(): Promise<Workflow[]> {
  return workflowsData as Workflow[];
}
